<template>
  <div class="trace-redirect-page">
    <div class="container-fluid py-5">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6">
          <div class="card shadow-sm">
            <div class="card-body text-center py-5">
              <!-- 加载动画 -->
              <div v-if="!error" class="mb-4">
                <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                  <span class="sr-only">正在跳转...</span>
                </div>
              </div>
              
              <!-- 错误提示 -->
              <div v-if="error" class="alert alert-danger" role="alert">
                <h5 class="alert-heading">
                  <i class="fa fa-exclamation-triangle me-2"></i>跳转失败
                </h5>
                <p>{{ error }}</p>
                <hr>
                <button class="btn btn-primary" @click="retryRedirect">重试</button>
              </div>
              
              <!-- 加载提示 -->
              <div v-else>
                <h4 class="mb-3">正在跳转到溯源查询页面...</h4>
                <p class="text-muted">交易单号: <strong>{{ tradeNo || '未知' }}</strong></p>
                <p class="text-muted small mt-3">如果页面没有自动跳转，请点击下方按钮</p>
                <button class="btn btn-primary mt-3" @click="manualRedirect" v-if="redirectUrl">
                  手动跳转
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TraceRedirect',
  data() {
    return {
      tradeNo: null,
      redirectUrl: null,
      error: null
    }
  },
  mounted() {
    this.extractTradeNo()
    this.redirect()
  },
  methods: {
    // 从URL中提取交易单号
    extractTradeNo() {
      // 从路径参数获取
      this.tradeNo = this.$route.params.tradeNo || this.$route.params.billId
      
      // 从查询参数获取
      if (!this.tradeNo) {
        this.tradeNo = this.$route.query.tradeNo || this.$route.query.billId
      }
      
      // 从完整URL中提取（处理后端API URL格式）
      if (!this.tradeNo) {
        const fullUrl = window.location.href
        // 匹配模式：getOrdersByTradeNoWithTraceReport/交易单号
        let match = fullUrl.match(/getOrdersByTradeNoWithTraceReport\/([^/?&#]+)/)
        if (match && match[1]) {
          this.tradeNo = decodeURIComponent(match[1])
        } else {
          // 尝试从URL路径的最后一部分提取
          const pathParts = window.location.pathname.split('/').filter(p => p)
          const lastPart = pathParts[pathParts.length - 1]
          if (lastPart && !['trace', 'api', 'nxdepartmentorders', 'getOrdersByTradeNoWithTraceReport', 'redirect'].includes(lastPart)) {
            this.tradeNo = decodeURIComponent(lastPart)
          }
        }
      }
    },
    
    // 执行重定向
    redirect() {
      if (!this.tradeNo) {
        this.error = '无法从URL中提取交易单号，请检查URL是否正确'
        return
      }
      
      // 构建前端页面URL
      const baseUrl = window.location.origin
      this.redirectUrl = `${baseUrl}/trace/${encodeURIComponent(this.tradeNo)}`
      
      // 延迟跳转，让用户看到加载提示
      setTimeout(() => {
        this.$router.push({
          path: '/trace/' + encodeURIComponent(this.tradeNo)
        }).catch(err => {
          // 如果路由跳转失败，尝试直接跳转
          console.error('路由跳转失败:', err)
          window.location.href = this.redirectUrl
        })
      }, 500)
    },
    
    // 手动跳转
    manualRedirect() {
      if (this.redirectUrl) {
        window.location.href = this.redirectUrl
      } else {
        this.$router.push({
          path: '/trace/' + encodeURIComponent(this.tradeNo)
        })
      }
    },
    
    // 重试
    retryRedirect() {
      this.error = null
      this.extractTradeNo()
      this.redirect()
    }
  }
}
</script>

<style lang="less" scoped>
.trace-redirect-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding-top: 80px; // 为导航栏留出空间
  
  .card {
    border: none;
    border-radius: 15px;
    overflow: hidden;
    
    .card-body {
      background: white;
    }
  }
  
  .spinner-border {
    width: 3rem;
    height: 3rem;
    border-width: 0.3em;
  }
  
  h4 {
    color: #333;
    font-weight: 500;
  }
  
  .text-muted {
    color: #6c757d !important;
  }
  
  strong {
    color: #1a73e8;
    font-weight: 600;
  }
}
</style>

